import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { FaHome, FaCog, FaCalendarAlt, FaBell, FaInfoCircle, FaQuestionCircle, FaSignOutAlt, FaChevronRight, FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import DashboardLayout from '../../components/layout/DashboardLayout';
import './ProfileScreen.css';

const ProfileScreen = () => {
  const { user, setUser } = useUser();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  
  const logout = () => {
    localStorage.removeItem('ACCESS_TOKEN');
    setUser(null);
  };
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = async () => {
    await logout();
    navigate('/login');
    setShowLogoutConfirm(false);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const profileLinks = [
    {
      icon: <FaHome />,
      text: 'Home',
      onClick: () => navigate('/dashboard')
    },
    {
      icon: <FaCog />,
      text: 'Update Profile',
      onClick: () => navigate('/complete-profile')
    },
    {
      icon: <FaCalendarAlt />,
      text: 'Appointments',
      onClick: () => navigate('/appointments')
    },
    {
      icon: <FaBell />,
      text: 'Notifications',
      onClick: () => navigate('/notifications')
    },
    {
      icon: <FaInfoCircle />,
      text: 'About Us',
      onClick: () => navigate('/about-us')
    },
    {
      icon: <FaQuestionCircle />,
      text: 'Help',
      onClick: () => navigate('/contact-us')
    },
    {
      icon: <FaSignOutAlt />,
      text: 'Logout',
      onClick: handleLogoutClick
    }
  ];

  return (
    <DashboardLayout title="Profile" showBackButton={true}>
      <div className="profile-container">
        {/* Profile Picture Section */}
        <div className="profile-picture-section">
          <div className="profile-picture-container">
            <img
              src={user?.profilePicture?.secure_url || '/default-profile.svg'}
              alt="Profile"
              className="profile-picture"
              onError={(e) => {
                e.target.src = '/default-profile.svg';
              }}
            />
          </div>
          <h2 className="profile-name">{user?.name || user?.fullName}</h2>
          <p className="profile-email">{user?.email}</p>
          <p className="profile-mobile">{user?.mobile}</p>
        </div>

        {/* Profile Links */}
        <div className="profile-links">
          {profileLinks.map((link, index) => (
            <div
              key={index}
              className="profile-link"
              onClick={link.onClick}
            >
              <div className="link-icon">
                {link.icon}
              </div>
              <span className="link-text">{link.text}</span>
              <FaChevronRight className="link-arrow" />
            </div>
          ))}
        </div>

        {/* Logout Confirmation Popup */}
        {showLogoutConfirm && (
          <div className="logout-popup-overlay">
            <div className="logout-popup">
              <div className="logout-popup-header">
                <div className="logout-icon">
                  <FaExclamationTriangle />
                </div>
              </div>
              <div className="logout-popup-content">
                <h3>Confirm Logout</h3>
                <p>Are you sure you want to logout from your account?</p>
                <div className="logout-popup-actions">
                  <button className="logout-cancel-btn" onClick={cancelLogout}>
                    Cancel
                  </button>
                  <button className="logout-confirm-btn" onClick={confirmLogout}>
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ProfileScreen;